// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2wreY","inner":"Footer_inner__1eC7t","nextIcon":"Footer_nextIcon__22J36","innerLeft":"Footer_innerLeft__3ZtIm"};